<template>
  <div class="box-two property-item pt-4 booth-scheme">
    <img v-if="booth.previewImage" :src="booth.previewImage" />
    
    <div v-else>
      <em class="fa fa-picture-o" aria-hidden="true"></em>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useMainStore } from '@/store'

const mainStore = useMainStore()

// props
const props = defineProps({
  booth: {
    type: Object,
    required: true
  }
})

// computed props
const shoppingCart = computed(() => mainStore.settings.shopping_cart)

const scheme = computed(() => {
  if (props.booth.schemes.length === 0 || shoppingCart.value.booth_type === null) {
    return null
  }

  const matchingScheme = props.booth.schemes
    .filter((scheme) => {
      return scheme.booth_type === shoppingCart.value.booth_type.type
    })
    .find((scheme) => {
      return (
        parseFloat(scheme.width) === parseFloat(shoppingCart.value.width)
        && parseFloat(scheme.depth) === parseFloat(shoppingCart.value.depth)
      )
    })

  return (matchingScheme === undefined) ? null : matchingScheme
})
</script>